module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgklEQVQ4jWMYdIAR3UF3MuUaGBgY6pHFVKY/YryTKTdfZfqjRFweYEIzRADdECSQADIMQxSbQUQAnIahGKQy/dEHDBWYAKthLBjKcABQOGGXgQAMyTuZcv8xVGEB6AaTGkY4AU6v4fIKLhfjNAiXBlxg1GvkGdRIhD5i1AwkYGBgAACZFicurNizZwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/ic_btn_confirmation_press.png
// module id = 741
// module chunks = 0